import { StyleSheet } from 'react-native'
export default StyleSheet.create({
  tileList: {
    gap: 12,
    margin: 5
  },
  tileCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: 15,
    padding: 14,
    shadowColor: '#000',
    shadowOpacity: 0.06,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 4 },
    elevation: 2,
    width: '100%',
  },
  tileIconWrap: {
    width: 42,
    height: 42,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  tileText: {
    flex: 1,
  },
  tileTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: '#1F2937',
  },
  tileSubtitle: {
    marginTop: 2,
    fontSize: 13,
    color: '#6B7280',
  },
})
